
import { useTranslation } from 'react-i18next'
import { ProgressButton } from './ProgressButton'
import { isFromRecruiterActionsOnboarding } from '../../modules/recruiter-actions/utils/utils';
import { KEY_RETURN_TO_POST_ONBOARDING } from '../../shared/constants';
import { useNavigate } from 'react-router-dom';
import { finishOnboarding } from '../../shared/appInterface';
import { trackMixpanelEvent } from '../../shared/utils/helpers';
import CircleSuccess from '../../assets/icons/CircleSuccess';
import { useEffect } from 'react';

const NewProfileSuceesScreen = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
     /* KEY_RETURN_TO_POST_ONBOARDING won't be empty if the onboarding is triggered
     * via recruiter actions. */
    const returnToPostOnboarding = sessionStorage.getItem(KEY_RETURN_TO_POST_ONBOARDING);
    const isFromRecruiterActions = isFromRecruiterActionsOnboarding();
    const onCompletion = () => {
        if (isFromRecruiterActions) {
            // onboarding is completed via recruiter actions, take user back to recruiter actions page
            sessionStorage.removeItem(KEY_RETURN_TO_POST_ONBOARDING);
            return navigate(`${returnToPostOnboarding}?refetch=true`, { replace: true });
        }
        trackMixpanelEvent("onboarding_complete_apply_now_clicked");
        if((window as any)?.appInterface){

        }
        if((window as any)?.appInterface){
            finishOnboarding();
        }
    };

    useEffect(() => {
        trackMixpanelEvent(
            "onboarding_complete_screen_shown",
            isFromRecruiterActions ? { source: "recruiter_action_profile_update" } : {}
        );
    }, []);

    return (

        <div className="flex flex-col h-screen items-center justify-center bg-white overflow-hidden">
            <div className='flex-grow flex flex-col p-4'>

                <div className='h-[45%] flex w-screen px-3 pt-4 items-center justify-center'>
                    <div className="flex h-[100%] w-screen bg-[url(https://storage.googleapis.com/mumbai_apnatime_prod/cloudinary/success_profile_bg.svg)] bg-contain bg-no-repeat bg-clip-border items-center justify-center">
                        <CircleSuccess />
                    </div>
                </div>

                <div className='h-[55%] flex flex-col w-screen'>
                    <div className='flex flex-col gap-4 w-full text-center items-center'>
                        <p>
                            <span className='px-2'>✨</span>
                            <span className='font-bold text-xl bg-gradient-to-r from-[#FF8800] to-[#E63535] bg-clip-text text-transparent'>{t("PROFILE_SUCCESS.TITLE")}</span>
                            <span className='px-2'>✨</span>
                        </p>
                        
                        <p className='font-bold text-xl px-4'>{t("PROFILE_SUCCESS.DESCRIPTION")}</p>
                    </div>
                    <div className='flex flex-grow w-full relative'>
                        <div className='flex flex-col items-center absolute bottom-[10%] m-6'>
                            <p className='text-sm text-center'>{t("PROFILE_SUCCESS.ADDITIONAL_HINT")}</p>
                        </div>
                    </div>
                </div>

            </div>
            <div className='flex p-4 bottom-0 w-screen'>
                <ProgressButton
                    width="100%"
                    text="Proceed"
                    textColor='#fff'
                    primaryColor="#1F8268"
                    secondaryColor="#005F3E"
                    duration={2000}
                    onClick={onCompletion}
                    onCompletion={onCompletion}
                />
            </div>
        </div>
    )
}

export default NewProfileSuceesScreen